var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElixirLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#F4F2ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.418 28.5034C118.887 33.6538 104.861 48.6865 91.338 73.6015C71.0538 110.974 44.8557 164.081 80.9307 206.129C97.62 225.581 125.176 237.062 161.34 218.879C190.391 204.272 198.471 162.353 188.041 142.654C166.526 102.02 144.698 91.9975 138.853 66.7979C134.956 49.9982 133.145 37.2334 133.418 28.5034V28.5034Z",
    fill: "url(#paint0_linear_306_58)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.418 28C118.813 33.2035 104.787 48.2362 91.3378 73.0981C71.1641 110.391 44.8554 163.578 80.9304 205.625C97.6198 225.078 124.821 231.364 139.915 219.827C149.755 212.306 156.447 205.137 160.303 190.031C164.596 173.211 161.302 150.567 159.045 140.164C156.189 127.001 155.254 112.553 156.24 96.8214C155.893 96.3979 155.633 96.081 155.461 95.8706C147.603 86.254 141.54 77.8776 138.853 66.2945C134.956 49.4948 133.144 36.7299 133.418 28V28Z",
    fill: "url(#paint1_linear_306_58)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.325 34.543C107.723 45.2935 97.6091 63.3258 90.9841 88.6398C81.0465 126.611 79.9696 161.626 83.4745 181.993C90.2688 221.475 125.493 236.462 161.623 218.085C183.857 206.775 193.118 182.499 192.628 156.148C192.12 128.864 139.395 97.9413 130.057 75.1707C123.832 59.9903 120.921 46.4477 121.325 34.543V34.543Z",
    fill: "url(#paint2_linear_306_58)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.811 105.732C172.124 126.654 175.68 141.218 166.479 149.424C152.677 161.734 118.925 169.765 97.9271 154.875C83.9288 144.948 78.6324 123.652 82.0378 90.9883C76.2593 103.056 71.3735 115.281 67.3804 127.663C63.3874 140.045 62.2213 153.002 63.8823 166.535C68.8865 176.659 81.0536 183.42 100.384 186.82C129.378 191.918 156.821 189.399 175.236 180.116C187.512 173.928 193.319 167.767 192.655 161.635C193.099 152.579 190.306 143.959 184.278 135.773C178.25 127.588 168.761 117.574 155.811 105.732V105.732Z",
    fill: "url(#paint3_linear_306_58)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.0601 84.8403C91.9237 99.9501 95.8089 114.314 103.715 127.931C115.575 148.358 129.419 168.541 150.135 185.272C163.946 196.425 174.981 200.029 183.241 196.082C176.457 208.224 169.243 214.174 161.6 213.931C150.135 213.567 136.156 208.557 113.758 181.64C98.8252 163.696 88.6099 146.722 83.1118 130.718C83.9837 124.369 84.9082 118.045 85.8854 111.747C86.8626 105.448 88.9209 96.4794 92.0601 84.8403V84.8403Z",
    fill: "url(#paint4_linear_306_58)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.098 105.576C128.365 117.885 133.155 137.575 127.098 150.684C121.041 163.794 93.0644 187.476 100.787 208.339C108.51 229.201 127.33 224.517 139.135 214.903C150.94 205.288 157.259 189.655 158.66 178.661C160.061 167.666 155.309 146.512 153.763 128.111C152.733 115.844 153.432 105.326 155.861 96.5575L152.243 92.0054L130.951 85.7012C127.537 90.7453 126.253 97.3703 127.098 105.576V105.576Z",
    fill: "url(#paint5_linear_306_58)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.698 44.6094C127.807 47.5213 121.278 53.2912 115.111 61.9192C105.86 74.861 101.148 82.6189 104.636 108.273C106.961 125.376 108.625 141.11 109.628 155.475L139.45 68.8285C138.354 64.4134 137.442 60.4261 136.715 56.8664C135.987 53.3068 135.315 49.2211 134.698 44.6094V44.6094Z",
    fill: "url(#paint6_linear_306_58)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.393 68.6553C131.823 73.074 125.957 82.1269 121.795 95.8139C117.633 109.501 113.826 128.635 110.373 153.216C114.978 137.582 118.033 126.258 119.538 119.244C121.795 108.724 122.566 93.8468 128.559 83.7467C132.554 77.0133 136.165 71.9828 139.393 68.6553V68.6553Z",
    fill: "#330A4C",
    fillOpacity: 0.316321
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.34 215.306C116.798 217.086 123.313 218.668 123.883 220.053C124.739 222.131 122.306 224.031 115.391 222.754C110.781 221.903 107.097 219.42 104.34 215.306Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.599 44.6094C103.747 52.7956 97.8089 61.4742 92.7858 70.6454C87.7628 79.8165 84.1737 86.6585 82.0185 91.1714C81.3505 94.5373 81.0244 99.5038 81.0404 106.071C81.0563 112.638 81.6243 119.94 82.7444 127.976C83.7251 112.239 86.7272 96.9632 91.7509 82.1492C96.7745 67.3351 103.057 54.8218 110.599 44.6094V44.6094Z",
    fill: "#EDEDED",
    fillOpacity: 0.603261
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_58",
    x1: 130.619,
    y1: 43.2442,
    x2: 123.681,
    y2: 227.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.385275
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_306_58",
    x1: 133.755,
    y1: 43.1976,
    x2: 61.2461,
    y2: 202.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D67AF",
    stopOpacity: 0.671932
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8DAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_306_58",
    x1: 141.849,
    y1: 94.6868,
    x2: 141.849,
    y2: 222.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26053D",
    stopOpacity: 0.761634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7B4B4",
    stopOpacity: 0.277683
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_306_58",
    x1: 76.2781,
    y1: 103.33,
    x2: 108.812,
    y2: 189.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91739F",
    stopOpacity: 0.45955
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32054F",
    stopOpacity: 0.539912
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_306_58",
    x1: 163.238,
    y1: 209.304,
    x2: 73.7728,
    y2: 135.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463D49",
    stopOpacity: 0.331182
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#340A50",
    stopOpacity: 0.821388
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_306_58",
    x1: 144.85,
    y1: 95.8913,
    x2: 81.7508,
    y2: 191.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#715383",
    stopOpacity: 0.145239
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4",
    stopOpacity: 0.233639
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_306_58",
    x1: 150.884,
    y1: 125.17,
    x2: 106.199,
    y2: 122.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A1A8",
    stopOpacity: 0.356091
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#370C50",
    stopOpacity: 0.581975
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElixirLight);
export default __webpack_public_path__ + "static/media/Elixir-Light.4b58dd18c90a370ab0e9cd83a8638a07.svg";
export { ForwardRef as ReactComponent };